module.exports = __webpack_public_path__ + "img/purple.20efb6d.svg";